import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'promotion-coupon-strip',
  name: '优惠券条',
  icon: '券',
  group: '营销组件',
  description: '展示公开可领优惠券，无数据注入时自动拉取当前租户券列表',
  defaultProps: {
    title: '会员专享券',
    subtitle: '先领券再下单，优惠立享',
    buttonText: '去领取'
}
}
